import { createFileRoute } from "@tanstack/react-router";
import { Palette } from "lucide-react";

import { AuditScoreCards } from "@/components/brand-intel/brand-audit/audit-score-cards";
import { VisualIdentityAnalysis } from "@/components/brand-intel/brand-audit/visual-identity-analysis";
import { SubBrandVoiceMapping } from "@/components/brand-intel/brand-audit/sub-brand-voice-mapping";
import { CrossChannelConsistency } from "@/components/brand-intel/brand-audit/cross-channel-consistency";
import { AIRecommendations } from "@/components/brand-intel/brand-audit/ai-recommendations";
import { PageHeader } from "@/components/layout/heading";

export const Route = createFileRoute("/dashboard/intelligence/_layout/brand-audit")({
  component: BrandAudit,
});

export function BrandAudit() {
  return (
    <section className="w-full space-y-6">
      <PageHeader title={
        <div className="flex items-center gap-2">
          <Palette className="size-5 text-muted-foreground" strokeWidth={2.5} />
          Brand Audit — Visual Identity, Messaging &amp; Digital Presence
        </div>
      } />

      <AuditScoreCards />

      <div className="grid gap-5 lg:grid-cols-2">
        <VisualIdentityAnalysis />
        <SubBrandVoiceMapping />
      </div>

      <CrossChannelConsistency />
      <AIRecommendations />
    </section>
  );
}
